var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"denglv-content"},[_c('img',{staticClass:"banner",attrs:{"src":require("../assets/images/denglv-img.png"),"alt":""}})])])
}]

export { render, staticRenderFns }